import * as Yup from "yup";

export const transactionFeeSchema = Yup.object().shape({
  feeType: Yup.string().required("Fee type is required"),
  basePercentage: Yup.number()
    .typeError("Base percentage must be a number")
    .min(0, "Must be at least 0")
    .max(100, "Cannot exceed 100")
    .required("Base percentage is required"),
  reducedPercentage: Yup.number()
    .typeError("Reduced percentage must be a number")
    .min(0, "Must be at least 0")
    .max(100, "Cannot exceed 100")
    .required("Reduced percentage is required"),
  valueCap: Yup.number()
    .typeError("Value cap must be a number")
    .min(0, "Must be at least 0")
    .required("Value cap is required"),
});


export const courierFeeValidationSchema = Yup.object({
  courierId: Yup.string().required("Courier is required"),
  baseFee: Yup.number().required("Base fee is required"),
  perKmCharge: Yup.number().required("Per KM charge is required"),
  weightFactor: Yup.number().required("Weight factor is required"),
  insurancePercentage: Yup.number().required("Insurance % is required"),
});